import React from 'react';

const Judge = () => {
    return <div>Judge component</div>;
};

export default Judge;
